<template>
    <div v-if="orcs && orcs.length" class="mb-3">
        <div class="card mb-0" v-for="(orc, iox) in orcs" :key="iox">
            <div class="card-header d-flex justify-content-between alert-info">
                <div>
                    <a data-toggle="collapse" :href="'#orc' + iox" class="card-link">
                        Orçamento #{{ orc.id_orcamento }} 
                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                        {{ orc.st_titulo }}
                    </a>
                </div>
                <div>
                    {{ $util.getFormatDate(orc.created_at) }}
                </div>
            </div>
            <div class="collapse" :id="'orc' + iox">
                <div class="card-body">
                    <div>
                        <i class="fa-solid fa-hashtag fa-fw mr-2"></i>
                        <a href="#" @click.prevent="abrir_orcamento(orc)" class="card-link">
                            {{ orc.id_orcamento }}
                        </a>
                    </div>
                    <div v-if="orc.unidade_operacao">
                        <i class="fa fa-building-o fa-fw mr-2" aria-hidden="true"></i>
                        {{ orc.unidade_operacao.st_nome }}
                    </div>
                    <div v-if="orc.plano">
                        <i class="far fa-credit-card fa-fw mr-2"></i>
                        {{ orc.plano.search }}
                    </div>
                    <div v-if="orc.usuario">
                        <i class="fa fa-user fa-fw mr-2" aria-hidden="true"></i>
                        {{ orc.usuario.st_login }}
                    </div>
                    <div v-if="orc.dt_validade">
                        <i class="fa-solid fa-hourglass-end fa-fw mr-2"></i>
                        {{ $util.getFormatDate(orc.dt_validade) }}
                    </div>
                    <div v-if="orc.id_pagamento_atendimento">
                        <i class="fas fa-dollar-sign fa-fw mr-2"></i>
                        Pagamento #{{ orc.id_pagamento_atendimento }}
                    </div>
                    <div v-if="orc.st_observacoes">
                        <i class="fa-solid fa-comment fa-fw mr-2"></i>
                        {{ orc.st_observacoes }}
                    </div>

                    <!-- Procedimentos Orçados -->
                    
                    <az-sub-title title="Procedimentos Orçados" class="mt-3"></az-sub-title>
                    
                    <template v-if="orc.vacinas && orc.vacinas.length">
                        <table class="table table-sm small table-hover">
                            <thead>
                                <th>Descrição</th>
                                <th class="text-right">Orçado</th>
                                <th class="text-right">Agendado</th>
                                <th class="text-right">Atendido</th>
                            </thead>
                            <tbody>
                                <tr v-for="(proc, ipx) in orc.vacinas" :key="ipx" :class="'table-' + proc.color">
                                    <td>
                                        {{ proc.search }}
                                    </td>
                                    <td class="text-right">{{ proc.in_quantidade }}</td>
                                    <td class="text-right">{{ proc.marcado }}</td>
                                    <td class="text-right">{{ proc.atendido }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>

                    <template v-else>
                        <div v-if="orc.js_procedimentos && orc.js_procedimentos.length">
                            <ul class="list-group">
                                <li class="list-group-item py-2" v-for="(proc, idx) in orc.js_procedimentos" :key="idx">
                                    <div>
                                        {{ proc.procedimento.search }}
                                        <span v-if="proc.procedimento.in_quantidade > 1" class="badge badge-secondary ml-1">x{{ proc.procedimento.in_quantidade }}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </template>

                    <!-- Marcações / Atendimentos -->

                    <template v-if="orc.marcacoes && orc.marcacoes.length">
                        <az-sub-title title="Marcações / Atendimentos" class="mt-3"></az-sub-title>

                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between py-2" v-for="(marcacao, idx) in orc.marcacoes" :key="idx">
                                <div>
                                    {{ $util.getFormatDate(marcacao.dt_inicio) }}
                                    <div v-if="marcacao.id_atendimento && marcacao.atendimento_procedimentos" class="small text-muted">
                                        <ul>
                                            <li v-for="(atp, iax) in marcacao.atendimento_procedimentos" :key="iax">
                                                {{ atp.procedimento.search }}
                                                <span class="badge badge-secondary ml-1" v-if="atp.in_quantidade > 1">x{{ atp.in_quantidade }}</span>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="small text-muted" v-else-if="marcacao.procedimento">
                                        {{ marcacao.procedimento.search }}
                                    </div>
                                </div>
                                <div class="text-right">
                                    <span v-if="marcacao.id_atendimento">
                                        <a href="#" @click.prevent="abrir_atendimento(marcacao)" class="card-link">
                                            #{{ marcacao.id_atendimento }}
                                        </a>
                                    </span>
                                    <span v-else>
                                        <span v-if="marcacao.ch_estado_marcacao == 'B'" class="badge badge-danger">Bloqueado</span>
                                        <span v-else-if="marcacao.ch_estado_marcacao == 'A'" class="badge badge-primary">Agendado</span>
                                    </span>
                                    <div v-if="marcacao.medico" class="small text-muted">
                                        {{ marcacao.medico.search }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                        
                        <pre v-if="false">{{ orc.marcacoes }}</pre>
                    </template>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzSubTitle from '../../util/AzSubTitle.vue';

export default {
  
    data() {
        return { 
        };
    },

    components: { AzSubTitle },

    props: ['orcs'], 

    methods: { 
        abrir_atendimento (marcacao) { 
            $('.modal').modal('hide');

            this.$util.abrir_atendimento(this, marcacao.id_atendimento);
        },

        abrir_orcamento(orcamento) { 
            $('.modal').modal('hide');

            this.$router.push({ name: 'rorcamento', params: { id_orcamento: orcamento.id_orcamento }});
        },

        toggle(orc) { 
            console.log('orc', orc);
            orc.fl_ativo = !orc.fl_ativo;
        }
    }
}
</script>
